import { useEffect, useRef } from 'react'

const AutoCompleteInput = ({
  isoCode,
  googleResponse,
  setGoogleResponse,
  className = '',
  placeholder = 'Enter the address',
  handleBlur = () => {}
}) => {
  const searchInput = useRef<HTMLInputElement>(null)

  useEffect(() => {
    initAutocomplete()

    if (googleResponse?.name != null) {
      searchInput.current!.value = googleResponse?.name
    }
  }, [])

  // do something on address change
  const onAddressChange = (autocomplete) => {
    const { place_id: placeId, name } = autocomplete.getPlace()

    const placeService = new google.maps.places.PlacesService(
      searchInput.current
    )

    placeService.getDetails(
      {
        placeId,
        fields: ['formatted_phone_number', 'geometry']
      },
      (response) => {
        setGoogleResponse({
          formattedPhoneNumber: response?.formatted_phone_number,
          formattedAddress: searchInput.current.value,
          name,
          latitude: response?.geometry?.location?.lat(),
          longitude: response?.geometry?.location?.lng()
        })
      }
    )
  }

  const initAutocomplete = () => {
    if (!searchInput.current) return

    const options = {
      componentRestrictions: { country: isoCode },
      fields: ['place_id', 'name']
    }

    const autocomplete = new google.maps.places.Autocomplete(
      searchInput.current,
      options
    )

    autocomplete.addListener('place_changed', () => {
      onAddressChange(autocomplete)
    })
  }

  return (
    <div className="App">
      <div>
        <div className="search">
          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault()
              return false
            }}
          >
            <input
              onBlur={handleBlur}
              className={className}
              style={{ height: '38px' }}
              ref={searchInput}
              role="presentation"
              type="text"
              placeholder={placeholder}
              required
            />
          </form>
        </div>
      </div>
    </div>
  )
}

export default AutoCompleteInput
